import { render, staticRenderFns } from "./ProfileInfo.vue?vue&type=template&id=a866a8f4&scoped=true&"
import script from "./ProfileInfo.vue?vue&type=script&lang=ts&"
export * from "./ProfileInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileInfo.vue?vue&type=style&index=0&id=a866a8f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a866a8f4",
  null
  
)

export default component.exports